module.exports = __webpack_public_path__ + "static/min-time-duration1-095f2dbd888033aafda3c02416b4a2ab.png";